module.exports = __webpack_public_path__ + "img/aditional-services.aa7f7e25.jpg";